import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EInterceptorOptionsHTTPHeaders } from "src/app/_helpers/interceptors/EInterceptorOptionsHTTPHeaders";
import { Utilities } from "src/app/_helpers/utility/utilities";
import { IRelativeRiskAssessment, IUnsavedRelativeRiskAssessment } from "src/app/_interfaces/IRelativeRiskAssessment";
import { WfdssCase } from "src/app/_models/incident/wfdssCase/wfdssCase";
// import { environment } from "../../../environments/environment";
import { ConfigService } from "../config.service";

@Injectable({
  providedIn: "root",
})
export class RelativeRiskDataService {
  private readonly baseUrl = this.environment.caseApi.baseUrl;
  constructor(private httpSvc: HttpClient, private environment: ConfigService) {}

  /**
   * @description: Creates or updates the realtive risk assessment for the corresponding wfdss case
   */
  putRelativeRiskAssessmentForWfdssCaseId(
    wfdssCaseId: WfdssCase["wfdssCaseId"],
    relativeRiskAssessment: IUnsavedRelativeRiskAssessment
  ) {
    const dataToSave = this.addRequiredKeys(
      relativeRiskAssessment,
      wfdssCaseId
    );
    return this.httpSvc.put(
      `${this.baseUrl}/cases/${wfdssCaseId}/latestRelativeRiskAssessment`,
      dataToSave
    );
  }

  getLatestRelativeRiskForWfdssCaseId(wfdssCaseId: WfdssCase["wfdssCaseId"]) {
    return this.httpSvc.get<IRelativeRiskAssessment>(
      `${this.baseUrl}/cases/${wfdssCaseId}/latestRelativeRiskAssessment`,
      {
        headers: Utilities.appendHTTPHeaderForInterceptor([
          EInterceptorOptionsHTTPHeaders.SuppressErrorInterceptor,
        ]),
      }
    );
  }

  addRequiredKeys(
    unsavedRelativeRiskAssessment: IUnsavedRelativeRiskAssessment,
    wfdssCaseId
  ) {
    const assessmentToSave: Partial<IRelativeRiskAssessment> = {
      ...unsavedRelativeRiskAssessment,
    };

    assessmentToSave.relativeRiskId = null;
    assessmentToSave.userIdThatCompletedThisAssessment ??= null;
    assessmentToSave.wfdssCaseId ??= wfdssCaseId;
    assessmentToSave.isReadyForPublication ??= false;
    assessmentToSave.dateTimeWhenMarkedReadyForPublication ??= null;
    
    return assessmentToSave;
  }
}
